import { AboutContent } from '../components/About/index.types';
import { Service } from '../components/ServiceList/index.types';
import { HELPCENTER_BASE_URL } from '../constants/url';
import { Organisation } from '../enums/common';
import { getOrganisation } from '../utils/common';
import { get } from '../utils/fetch';

export const getServices: () => Promise<Service[]> = async () => {
    const { data } = await get(`${HELPCENTER_BASE_URL}/service`);
    return data;
};

export const getAboutContent: () => Promise<AboutContent> = async () => {
    if (getOrganisation() !== Organisation.IXIGO) {
        throw new Error('Invalid organisation');
    }

    const headingsPromise = get('/action/content?searchFor=cmsContent&page=helpCenter&identifier=text_en&token=config');
    const questionsPromise = get(`${HELPCENTER_BASE_URL}/questions/general?tags=about-ixigo`);
    const [headings, questions] = await Promise.all([headingsPromise, questionsPromise]);
    return {
        disclaimer: headings.data.disclaimer,
        headings: headings.data.aboutFAQ,
        questions: questions.data,
    };
};
